
export default function enhancePrototypes() {
  Number.prototype.format = function(n, x, s, c) {
    const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
    const num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
  };

  Number.prototype.formatFr = function() {
    return this.format(0, 3, ' ');
  };

  Number.prototype.formatEuros = function() {
    return this.formatFr() + ' €';
  };

  Number.prototype.limit = function(min, max) {
    return Math.min(Math.max(this, min), max);
  };

  Number.prototype.roundN = function(n) {
    return n * Math.round(this.toFixed(2) / n);
  };
}